module.exports = __webpack_public_path__ + "img/dead@2x.e098aa72.png";